export const useStickySearchData = defineStore('stickySearchData', {
    state: () => ({
        top8Trending: {},
        isFetchTop8Trending: false,
        top8TrendingSuspends: [],

        categoryList: null,
        isFetchCategoryList: false,
        categoryListSuspends: [],
    }),
    getters: {
    },
    actions: {
        async fetchTop8Trending() {
            if (this.top8Trending.length) {
                return this.top8Trending
            }
            if (this.isFetchTop8Trending) {
                return new Promise((resolve) => {
                    this.top8TrendingSuspends.push(resolve)
                })
            }
            this.isFetchTop8Trending = true
            const { locale } = useI18n()
            try {
                const resp = await useGetTrendsList({
                    pageNum: 1,
                    pageSize: 8,
                    keyWords: '',
                    language: locale.value
                }, {
                    client: true
                })
                this.top8Trending = {...resp.data}
            }catch (_) {
                console.info('请求搜索栏热搜词失败 -> ', _)
            }
            for (const suspend of this.top8TrendingSuspends) {
                suspend(this.top8Trending)
            }
            this.top8TrendingSuspends = []
            this.isFetchTop8Trending = false
            return this.top8Trending
        },
        async fetchCategoryList() {
            if (this.categoryList) {
                return this.categoryList
            }
            if (this.isFetchCategoryList) {
                return new Promise((resolve) => {
                    this.categoryListSuspends.push(resolve)
                })
            }
            this.isFetchCategoryList = true
            const { locale } = useI18n()
            try {
                const resp = await useGetCategoryList({
                    language: locale.value,
                })
                this.categoryList = resp.data
            } catch(_) {
                console.info('请求搜索栏分类失败 -> ', _)
            }
            for (const suspend of this.categoryListSuspends) {
                suspend(this.categoryList)
            }
            this.categoryListSuspends = []
            this.isFetchCategoryList = false
            return this.categoryList
        },
    }
}) 